import { Table } from "antd";
import React from "react";

const Table_v2 = ({
    className,
    columns,
    dataSource,
    ...rest
}) => {
    return (
        <div style={{marginTop: '16px'}}>
            <Table
                columns={columns}
                dataSource={dataSource}
                className={`table_v2 ${className}`}
                locale={{emptyText: 'No Data'}}
                {...rest}
            />
        </div>
    )
}

export default Table_v2;